// Hand-written (TSX) articles that predate the markdown pipeline.
// Each has a title-bearing social cover; most also have text-free header art.

export interface LegacyPost {
  slug: string;
  title: string;
  date: string;
  isoDate: string;
  excerpt: string;
  category: string;
  tags: string[];
  /** Title-bearing 1200x630 image for cards and social previews. */
  cover: string;
  /** Text-free 3:1 artwork shown at the top of the article. */
  editorial?: string;
}

const SITE_URL = 'https://www.greyfielddata.com';

export const legacyPosts: LegacyPost[] = [
  {
    slug: 'bigquery-vs-snowflake-ecommerce',
    title: 'BigQuery vs Snowflake vs Azure for Ecommerce',
    date: 'Feb 14, 2026',
    isoDate: '2026-02-14',
    excerpt: 'Which data warehouse is better for ecommerce brands? Compare BigQuery, Snowflake, and Azure Synapse for Amazon, Shopify, and DTC sellers with real pricing breakdowns and ecosystem integration analysis.',
    category: 'Comparison',
    tags: ['snowflake', 'ecommerce', 'warehouse'],
    cover: '/images/blog/bigquery-vs-snowflake-ecommerce/cover.png',
    editorial: '/images/blog/bigquery-vs-snowflake-ecommerce/editorial.webp',
  },
  {
    slug: 'power-bi-vs-tableau-ecommerce',
    title: 'Power BI vs Tableau vs Looker vs Metabase for Ecommerce',
    date: 'Feb 13, 2026',
    isoDate: '2026-02-13',
    excerpt: 'Which BI tool is best for ecommerce brands? Compare Power BI, Tableau, Looker, and Metabase for Amazon, Shopify, and multi-channel sellers with pricing, features, and real implementation examples.',
    category: 'Comparison',
    tags: ['powerbi', 'tableau', 'ecommerce', 'bi'],
    cover: '/images/blog/power-bi-vs-tableau-ecommerce/cover.png',
    editorial: '/images/blog/power-bi-vs-tableau-ecommerce/editorial.webp',
  },
  {
    slug: 'fivetran-vs-airbyte-vs-daton-ecommerce',
    title: 'Fivetran vs Airbyte vs Daton for Ecommerce',
    date: 'Feb 6, 2026',
    isoDate: '2026-02-06',
    excerpt: 'Which data integration tool is best for ecommerce? Compare Fivetran, Airbyte, and Daton for Amazon, Shopify, and TikTok Shop with pricing, reliability analysis, and warehouse efficiency insights.',
    category: 'Comparison',
    tags: ['ecommerce', 'pipelines'],
    cover: '/images/blog/fivetran-vs-airbyte-vs-daton-ecommerce/cover.png',
    editorial: '/images/blog/fivetran-vs-airbyte-vs-daton-ecommerce/editorial.webp',
  },
  {
    slug: 'sales-engineer-interview',
    title: 'What Does a Sales Engineer Do at a Tech Startup?',
    date: 'Nov 30, 2025',
    isoDate: '2025-11-30',
    excerpt: 'An in-depth conversation about the role of a Solutions Engineer in technical pre-sales at a late-stage startup in the data and AI space.',
    category: 'Interview',
    tags: ['career'],
    cover: '/images/blog/sales-engineer-interview/cover.png',
  },
  {
    slug: 'snowflake-explained',
    title: 'What Is Snowflake? A Non-Technical Guide',
    date: 'Nov 15, 2025',
    isoDate: '2025-11-15',
    excerpt: 'A non-technical explanation of what Snowflake is and why it became a game-changer in the data warehousing space.',
    category: 'Snowflake',
    tags: ['snowflake'],
    cover: '/images/blog/snowflake-explained/cover.png',
    editorial: '/images/blog/snowflake-explained/editorial.webp',
  },
  {
    slug: 'tableau-vs-powerbi',
    title: 'Tableau vs Power BI: An Honest Consultant Comparison',
    date: 'Nov 1, 2025',
    isoDate: '2025-11-01',
    excerpt: 'A comprehensive comparison of two leading business intelligence platforms based on years of consulting experience.',
    category: 'Comparison',
    tags: ['tableau', 'powerbi', 'bi'],
    cover: '/images/blog/tableau-vs-powerbi/cover.png',
    editorial: '/images/blog/tableau-vs-powerbi/editorial.webp',
  },
];

export function getLegacyPost(slug: string): LegacyPost {
  const post = legacyPosts.find((entry) => entry.slug === slug);
  if (!post) throw new Error(`Unknown legacy post: ${slug}`);
  return post;
}

export function legacySocialImage(slug: string): string {
  return `${SITE_URL}${getLegacyPost(slug).cover}`;
}
